import CABadge from '@ds/components/CABadge'
import CATableCell from '@ds/components/tables/CATableCell'
import { setPreviousRouteUrl } from '@vuejs/utils/stringUtils'
import { defineComponent, type PropType } from 'vue'

import type { Cell } from './DataTable'

export default defineComponent({
	name: 'DataTableCell',

	props: {
		cell: { required: true, type: Object as PropType<Cell> },
		index: { required: true, type: Number },
		width: { default: '', type: String },
	},

	computed: {
		cellWidth(): string {
			return this.width ? `style="width: ${this.width}"` : 'auto'
		},
	},

	methods: {
		handleCellClick() {
			if (this.cell.title.link) {
				setPreviousRouteUrl()
				window.location.href = this.cell.title.link
			}
		},

		handleCellDetailsClick() {
			if (this.cell.details?.link) {
				setPreviousRouteUrl()
				window.location.href = this.cell.details.link
			}
		},
	},

	render() {
		return (
			<CATableCell class={this.cell.title.class}>
				<div style={this.cellWidth}>
					{this.cell.title.link ?
						<a
							data-test={this.cell.title.dataTest}
							data-test-name={this.cell.title.dataTestName}
							v-tooltip={this.cell.title.tooltip}
							onClick={this.handleCellClick}
						>
							{this.cell.title.text}
						</a>

						:

						<span>
							{this.cell.badge && this.cell.badge.text ?
								<CABadge
									appearance={this.cell.badge.appearance}
									badgeStyle={this.cell.badge.style}
									dataTest={this.cell.badge.dataTest}
									disableTitleMutation={this.cell.badge.disableTitleMutation}
									text={this.cell.badge.text}
									tooltip={this.cell.badge.tooltip}
									type={this.cell.badge.type}
								/>

								:

								<span
									data-test={this.cell.title.dataTest}
									innerHTML={this.cell.title.text}
									v-tooltip={this.cell.title.tooltip}
								/>
							}
						</span>
					}

					{this.cell.details &&
						<span>
							<br />
							{this.cell.details.link ?
								<a
									class={this.cell.details.class}
									data-test={this.cell.details.dataTest}
									v-tooltip={this.cell.details.tooltip}
									onClick={this.handleCellDetailsClick}
								>
									{this.cell.details.text}
								</a>

								:

								<span
									class={this.cell.details.class}
									data-test={this.cell.details.dataTest}
									innerHTML={this.cell.details.text}
									v-tooltip={this.cell.details.tooltip}
								/>
							}
						</span>
					}
				</div>
			</CATableCell>
		)
	},
})
